// src/App.js
import '@aws-amplify/ui-react/styles.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';
import { Authenticator } from '@aws-amplify/ui-react';

import NavBar from './components/NavBar';
import Home from './pages/Home';
import Events from './pages/Events';
import CreateEvent from './pages/CreateEvent';
import UploadPage from './pages/UploadPage';
import EventDetail from './pages/EventDetail';
import Profile from './pages/Profile';
import Pricing from './pages/Pricing';
import CustomLogin from './components/CustomLogin';
import HomeLogin from './pages/HomeLogin';
import WallofLove from './pages/WallofLove';
import Contact from './pages/Contact';
import Guides from './pages/Guides';
import OnboardingPage from './pages/Onboarding';
import Success from './stripe/Success';
import Admins from './pages/Admins';
import GeneralConditions from './pages/Generalconditions';
import Privacy from './pages/Privacy';
import CGVCGU from './pages/CGVCGU';
import Cancel from './pages/Cancel';
import CancelCagnotte from './stripe/CancelCagnotte';
import SuccessCagnotte from './stripe/SuccessCagnotte';
import GeneralSettings from './pages/GeneralSettings';

import ProtectedRoute from './routes/ProtectedRoute';
import { UserProvider } from './contexts/UserContext';
import { EventProvider } from './contexts/EventContext';
import { EventDetailProvider } from './contexts/EventDetailContext';
import { UserDBProvider } from './contexts/UserDBContext';
import { ElementDeleteProvider } from './contexts/ElementDeleteContext';
import { WallofLoveProvider } from './contexts/WallofLoveContext';
import { StripeProvider } from './stripe/StripeContext';
import AdminRoute from './routes/AdminRoute';
import { HelmetProvider } from 'react-helmet-async';
import { StripeCagnotteProvider } from './stripe/StripeContextCagnotte';
import { GeneralSettingsProvider } from './contexts/GeneralSettingsContext';


import './App.css';
import './i18n';



Amplify.configure(awsconfig);

function AppContent() {
  const location = useLocation();

  // Masquer la NavBar uniquement pour la page upload : /:eventId/upload
  const isUploadPage = /^\/[^/]+\/upload$/.test(location.pathname);

  return (
    <>
      {!isUploadPage && <NavBar />}
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/:eventId/upload" element={<UploadPage />} />

          <Route path="/events" element={<ProtectedRoute><Events /></ProtectedRoute>} />
          <Route path="/events/:eventId" element={<ProtectedRoute><EventDetail /></ProtectedRoute>} />
          <Route path="/create-event" element={<ProtectedRoute><CreateEvent /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/homelogin" element={<ProtectedRoute><HomeLogin /></ProtectedRoute>} />
          <Route path="/onboarding" element={<ProtectedRoute><OnboardingPage /></ProtectedRoute>} />
          <Route path="/success" element={<ProtectedRoute><Success /></ProtectedRoute>} />
          <Route path="/success-cagnotte" element={<ProtectedRoute><SuccessCagnotte /></ProtectedRoute>} />
          <Route path="/cancel" element={<ProtectedRoute><Cancel /></ProtectedRoute>} />
          <Route path="/cancel-cagnotte" element={<ProtectedRoute><CancelCagnotte /></ProtectedRoute>} />
          <Route path="/admin" element={<AdminRoute><Admins /></AdminRoute>} />
          <Route path="/generalsettings" element={<ProtectedRoute><GeneralSettings /></ProtectedRoute>} />

          <Route path="/pricing" element={<Pricing />} />
          <Route path="/WallofLove" element={<WallofLove />} />
          <Route path="/contacts" element={<Contact />} />
          <Route path="/guides" element={<Guides />} />
          <Route path="/login" element={<CustomLogin />} />
          <Route path="/generalconditions" element={<GeneralConditions />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cgv-cgu" element={<CGVCGU />} />

        </Routes>
      </main>
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Authenticator.Provider>
        <UserProvider>
          <UserDBProvider>
            <GeneralSettingsProvider>
              <StripeProvider>
                <StripeCagnotteProvider>
                  <EventProvider>
                    <EventDetailProvider>
                      <ElementDeleteProvider>
                        <WallofLoveProvider>
                          <Router>
                            <AppContent />
                          </Router>
                        </WallofLoveProvider>
                      </ElementDeleteProvider>
                    </EventDetailProvider>
                  </EventProvider>
                </StripeCagnotteProvider>
              </StripeProvider>
            </GeneralSettingsProvider>
          </UserDBProvider>
        </UserProvider>
      </Authenticator.Provider>
    </HelmetProvider>
  );
}

export default App;